<div class="row data-container">
  <div class="width-47">
    <div class="row">
      <app-question [childId]="'currentDate'" [questionConfig]="userInputDetail.radioButtonStartDateConfig"
        [parent]="quoteForm" [controlName]="'currentDate'" (valueChange)='toggleCurrentDate($event)'
        (dateInputHandler)="checkDataChange($event)" [controllerData]="userInputDetail.startDate" [isdateReq]="true"
        (onDisplayMobileTooltipEmitter)="corpMobileTooltipReceiver(userInputDetail.radioButtonStartDateConfig)">
      </app-question>
    </div>

    <div class="row">
      <div [id]="'current-startDate-error'" class="form-validation-error" *ngIf="currentAndStartDateError">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p>{{contentData.currentAndStartDateErrorValidationMsg}}</p>
      </div>
    </div>
    <div class="row mt-5">
      <app-question [childId]="'increasedIncomePlayground'" (valueChange)='toggleIncomeSlider($event,"income")'
        [questionConfig]="userInputDetail.radioButtonincraeseincomeConfig" [parent]="quoteForm"
        [controlName]="'increasedincome'"
        (onDisplayMobileTooltipEmitter)="corpMobileTooltipReceiver(userInputDetail.radioButtonincraeseincomeConfig)">
      </app-question>
    </div>
    <div *ngIf="showIncomeSlider" class="row mt-5">
      <app-simple-slider [sliderId]="'increasedSlider'" [sliderConfig]="userInputDetail.sliderincreaseIncomeConfig"
        [parent]="quoteForm" [controlName]="'increasedincomeslider'"
        (onDisplayMobileTooltipEmitter)="corpMobileTooltipReceiver(userInputDetail.sliderincreaseIncomeConfig)"></app-simple-slider>
    </div>
  </div>
  <div class="width-6"></div>
  <div class="width-47">
    <div class="row">
      <app-simple-slider [sliderId]="'termSlider'" [sliderConfig]="userInputDetail.sliderTermConfig"
        [parent]="quoteForm" [controlName]="'termyear'" (onScrollEndHandler)="changeScrollParams($event)"
        (onDisplayMobileTooltipEmitter)="corpMobileTooltipReceiver(userInputDetail.sliderTermConfig)">
      </app-simple-slider>
    </div>

    <div class="row mt-5">
      <app-simple-slider [sliderId]="'termMonthSlider'" [sliderConfig]="userInputDetail.sliderMonthlyTermConfig"
        [parent]="quoteForm" [controlName]="'termmonth'" [disable]='disableSlider'
        (onScrollEndHandler)="changeScrollParams($event)"
        (onDisplayMobileTooltipEmitter)="corpMobileTooltipReceiver(userInputDetail.sliderMonthlyTermConfig)">
      </app-simple-slider>
    </div>

    <div class="row">
      <div [id]="controlName+'-error'" class="col-md-12 form-validation-error margin-top-3" *ngIf="sliderErrorVisible">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p>{{userInputDetail.sliderMonthlyTermConfig.validationMsg}}
        </p>
      </div>
    </div>
  </div>

  <div class="width-47">
    <div class="row mt-5">
      <app-question [childId]="'frequencyPlayground'" [questionConfig]="userInputDetail.radioButtonCORPFrequencyConfig"
        [parent]="quoteForm" [controlName]="'frequency'" [productCode]="'G'"
        (onDisplayMobileTooltipEmitter)="corpMobileTooltipReceiver(userInputDetail.radioButtonCORPFrequencyConfig)">
        <!-- (valueChange)='toggleFrequency($event)'> -->
      </app-question>
    </div>
  </div>
  <div class="questions-container col-md-2 clear-all width-6"></div>
  <div class="width-47">
    <div class="row mt-5">
      <app-question [childId]="'advancePlayground'" [questionConfig]="userInputDetail.radioButtonAdvanceConfig"
        [parent]="quoteForm" [controlName]="'advance'"
        (onDisplayMobileTooltipEmitter)="corpMobileTooltipReceiver(userInputDetail.radioButtonAdvanceConfig)">
      </app-question>
    </div>
  </div>

  <div class="width-47">
    <div class="row mt-5">
      <app-question [childId]="'taxfreeCashPlayground'" (valueChange)='toggleSlider($event,"taxfree")'
        [questionConfig]="userInputDetail.radioButtontaxfreeCashConfig" [parent]="quoteForm"
        [controlName]="'taxfreeRadioButton'"
        (onDisplayMobileTooltipEmitter)="corpMobileTooltipReceiver(userInputDetail.radioButtontaxfreeCashConfig)">
      </app-question>
    </div>

    <div *ngIf="showTaxfreeSlider" class="row mt-5">
      <app-simple-slider [sliderId]="'taxfreeSlider'"
        (calculatedValueClickHandler)="oncalculatedValue($event, 'primary')"
        [sliderConfig]="userInputDetail.sliderTaxfreeLumpsumConfig" [parent]="quoteForm"
        [controlName]="'taxfreelumpsum'" (onScrollEndHandler)="changeScrollParams($event)"
        [fundAmount]="(this.pensionArray && this.pensionArray.length > 0) ? this.pensionArray[0].fundValue : 0"
        (onDisplayMobileTooltipEmitter)="corpMobileTooltipReceiver(userInputDetail.sliderTaxfreeLumpsumConfig)"></app-simple-slider>
    </div>
    <div *ngIf="showTaxfreeInput" class="row">
      <!-- mt-5 -->
      <app-currency [source]="source" [parent]="quoteForm" [controllerData]="userInputDetail.taxfreeValueConfig"
        [controlName]="'fundValueTaxfree'" [componentName]="'yourOptions'"
        (currencyChangeEventEmitter)="taxfreeChangeHandler($event,'first')"
        (onDisplayMobileTooltipEmitter)="corpMobileTooltipReceiver(userInputDetail.taxfreeValueConfigs)">
      </app-currency>
    </div>
  </div>
</div>